module.exports = __webpack_public_path__ + "static/media/docs-signed.ea6c4542.svg";